import { render } from "./IconCalendarDays.vue?vue&type=template&id=4c7696b6"
const script = {}
script.render = render

export default script